import { COLOR } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivBorderContainer = styled.div`
  padding-bottom: 8px;
  border-bottom: 1px solid ${COLOR.GRAY200.code};
`;

export const DivContentWrapper = styled.div`
  padding: 8px;
`;

export const DivAppealTextWrapper = styled.div`
  text-align: center;
  margin-bottom: 8px;
`;

export const SpanAppealText = styled.span`
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
`;
